// extracted by mini-css-extract-plugin
export default {"top":"TopBar_top__eHdWr","dots":"TopBar_dots__CpF9x","dot":"TopBar_dot__hNFoP","title":"TopBar_title__ZYnJy"};